import script from "./MListaDeGrupos.vue?vue&type=script&setup=true&lang=ts"
export * from "./MListaDeGrupos.vue?vue&type=script&setup=true&lang=ts"

import "./MListaDeGrupos.vue?vue&type=style&index=0&id=04140521&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04140521"]])

export default __exports__